export const EscalateTpoChatControlTestIds = {
  ESCALATE_BUTTON: 'escalate-tpo-chat.escalate-button',
};
